import React from 'react';
import { Box, Center, Spinner, Text, VStack } from '@chakra-ui/react';
import { useLanguage } from '../i18n';
import { getPortalPageCopy } from '../portalPageCopy';

const CustomerPanelLoading = () => {
  const { lang } = useLanguage();
  const copy = getPortalPageCopy(lang, 'shared');
  return (
  <Center minH="100vh" bg="gray.50" px={6}>
    <VStack spacing={4}>
      <Box
        w="12"
        h="12"
        borderRadius="xl"
        bg="white"
        borderWidth="1px"
        borderColor="gray.200"
        display="grid"
        placeItems="center"
        boxShadow="sm"
      >
        <Spinner size="md" color="blue.500" thickness="3px" />
      </Box>
      <VStack spacing={1}>
        <Text fontSize="sm" fontWeight="semibold" color="gray.800">
          {copy.loadingPanel}
        </Text>
        <Text fontSize="xs" color="gray.500">
          {copy.checkingAccess}
        </Text>
      </VStack>
    </VStack>
  </Center>
  );
};

export default CustomerPanelLoading;
